<script>
	import { PAGES } from '$lib/utils/constants';

	export let content = {
		backgroundImg: {
			src: '',
			mobileSrc: '',
		},
		links: [
			{
				id: '',
				text: '',
				href: '',
				aria: '',
				target: '',
				rel: '',
				callback: null
			}
		]
	};
</script>

<footer
	class:max-sm:h-[12rem]={content?.links?.length === 0}
	class="relative h-[22rem] 4xl:h-[25rem]"
>
	<picture>
		<source
			media="(min-width: 1440px)"
			srcset={content?.backgroundImg?.src ? content?.backgroundImg?.src : '/assets-mkt/routes/subscription/grass_tall_v2_4x.png'}
		/>
		<source
			media="(min-width: 1200px)"
			srcset={content?.backgroundImg?.src ? content?.backgroundImg?.src : '/assets-mkt/routes/subscription/grass_tall_v2_2x.png'}
		/>
		<source
			media="(min-width: 640px)"
			srcset={content?.backgroundImg?.mobileSrc ? content?.backgroundImg?.mobileSrc : '/assets-mkt/routes/subscription/grass_tall_v2_1x.png'}
		/>
		<img
			src={content?.backgroundImg?.mobileSrc ? content?.backgroundImg?.mobileSrc : '/assets-mkt/routes/subscription/grass_tall_v2_1x.png'}
			alt="Green Banner"
			class="h-full w-full"
		/>
	</picture>
	{#if content?.links?.length > 0}
		<div class="absolute inset-0 mt-2 flex flex-col items-center justify-evenly">
			<div
				class="text-arial mt-[2rem] w-full text-center text-[1rem] font-regular leading-7 text-white sm:mt-[4rem] sm:w-[53rem] sm:text-[1.1rem] sm:leading-[2.2rem]"
			>
				{#each content.links as link, i}
					<a
						id={link.id}
						href={link.href}
						target={link.target || '_self'}
						rel={link.rel || null}
						on:click={link.callback ? link.callback : null}>{@html link.text}</a
					>
					{#if i !== 0 && i !== content.links.length - 1}
						<span>| </span>
					{/if}
				{/each}
			</div>
			<a href={PAGES.EXTERNAL.KID_SAFE} target="_blank">
				<img
					id="logo-kidsafe"
					width="130"
					height="50"
					alt="ABCmouse is certified by the kidSafe Seal Program."
					src="//www.kidsafeseal.com/sealimage/1643675032741265067/abcmouse_medium_darktm.png"
					class="w-[8rem] sm:w-[13rem]"
				/>
			</a>
		</div>
	{/if}
</footer>
